var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotGoodIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "url(#paint0_linear_2428_63434)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2428_63434)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 45C36.0457 45 45 36.0457 45 25C45 13.9543 36.0457 5 25 5C13.9543 5 5 13.9543 5 25C5 36.0457 13.9543 45 25 45Z",
    fill: "#FA834F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8898 22.6015C18.9807 22.2889 18.9975 21.9595 18.9391 21.6392C18.8806 21.319 18.7485 21.0167 18.553 20.7564C18.3576 20.4961 18.1043 20.2848 17.8131 20.1392C17.5219 19.9937 17.2008 19.918 16.8753 19.918C16.5497 19.918 16.2287 19.9937 15.9375 20.1392C15.6463 20.2848 15.3929 20.4961 15.1975 20.7564C15.0021 21.0167 14.8699 21.319 14.8114 21.6392C14.753 21.9595 14.7699 22.2889 14.8607 22.6015H18.8898Z",
    fill: "#CCA332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.966 22.6015C35.0568 22.2889 35.0737 21.9595 35.0153 21.6392C34.9568 21.319 34.8246 21.0167 34.6292 20.7564C34.4338 20.4961 34.1804 20.2848 33.8892 20.1392C33.598 19.9937 33.277 19.918 32.9514 19.918C32.6259 19.918 32.3048 19.9937 32.0136 20.1392C31.7224 20.2848 31.4691 20.4961 31.2737 20.7564C31.0782 21.0167 30.9461 21.319 30.8876 21.6392C30.8292 21.9595 30.846 22.2889 30.9369 22.6015H34.966Z",
    fill: "#CCA332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.873 30.0454C16.873 30.0454 23.4188 22.7791 33.9169 28.6399",
    stroke: "#CCA332",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2428_63434",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2428_63434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotGoodIconSvg);
export default __webpack_public_path__ + "static/media/notGood-icon-svg.8d986cb4178ca67129893e94d46c455d.svg";
export { ForwardRef as ReactComponent };